// extracted by mini-css-extract-plugin
module.exports = {"course-list-wrapper":"course-list-wrapper__2wQOP","course-list":"course-list__1Lnyt"};